if (!customElements.get('bt-service-kit-models')) {
    customElements.define('bt-service-kit-models', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.parts = new Map(JSON.parse(this.querySelector('[data-kit-parts]').textContent).map(part => [part.key, part]));
        this.words = JSON.parse(this.querySelector('[data-kit-text]').textContent);
        this.preview = this.dataset.preview === 'true';
        this.money = new Intl.NumberFormat(this.dataset.locale || 'de-CH', {style:'currency', currency:this.dataset.currency || 'CHF'});
        this.groups = [...this.querySelectorAll('[data-group]')];
        this.choiceOptions = new Map(this.groups.map(card => [card.dataset.group, [...(card.querySelector('[data-choice]')?.options || [])].map(option => option.cloneNode(true))]));
        this.model = this.querySelector('[data-model]');
        this.submit = this.querySelector('[data-submit]');
        this.status = this.querySelector('[data-status]');
        this.addEventListener('change', event => {if (event.target.matches('[data-choice]') && event.target.value) event.target.closest('[data-group]').querySelector('[data-select-group]').checked = true; this.status.textContent = ''; this.update();});
        this.querySelector('[data-reset]').addEventListener('click', () => {this.querySelectorAll('[data-select-group]').forEach(input => input.checked = false); this.activeModel = null; this.status.textContent = ''; this.update();});
        this.submit.addEventListener('click', () => this.add());
        this.update();
      }
      update() {
        const model = this.model.value;
        const changedModel = this.activeModel !== model;
        this.activeModel = model;
        this.selected = [];
        this.pending = false;
        const modelOption = this.model.selectedOptions[0];
        const fuelNote = this.querySelector('[data-fuel-note]:not(option)');
        if (fuelNote && modelOption) fuelNote.textContent = modelOption.dataset.fuelNote || '';

        this.groups.forEach(card => {
          const group = card.dataset.group;
          const choice = card.querySelector('[data-choice]');
          const candidates = [...this.parts.values()].filter(item => item.group === group && item.models.split(',').map(code => code.trim()).includes(model));
          const checkbox = card.querySelector('[data-select-group]');
          card.hidden = candidates.length === 0;
          if (changedModel || card.hidden) checkbox.checked = false;
          if (choice) {
            if (changedModel) {
              const options = this.choiceOptions.get(group).filter(option => !option.value || candidates.some(item => item.key === option.value));
              choice.replaceChildren(...options.map(option => option.cloneNode(true)));
            }
            if (changedModel || !candidates.some(item => item.key === choice.value) && choice.value) choice.value = (group === 'fuel' || group === 'coils' || group === 'automatic') && candidates.length > 1 ? '' : candidates[0]?.key || '';
            choice.hidden = candidates.length < 2;
            card.querySelector('[data-choice-label]').hidden = choice.hidden;
          }
          const part = choice ? candidates.find(item => item.key === choice.value) : candidates[0];
          const usable = part && Number.isFinite(part.price) && part.price > 0 && (this.preview || part.available && part.id);
          const needsChoice = !!choice && !choice.value;
          checkbox.disabled = !needsChoice && !usable;
          if (checkbox.disabled) checkbox.checked = false;
          if (checkbox.checked && needsChoice) this.pending = true;
          card.querySelector('[data-code]').textContent = part ? part.code : (this.words[group + '_prompt'] || '');
          card.querySelector('[data-note]').textContent = !part ? '' : !this.preview && !part.available ? this.words.unavailable : (group === 'cabin' ? this.words.pair : group === 'automatic' ? this.words.set : part.quantity > 1 ? part.quantity + ' ' + (group === 'engine_oil' ? this.words.litres : this.words.pieces) : this.words.one) + (!this.preview && part.inventoryQuantity > 0 ? ' · ' + this.words.stock_count.replace('__COUNT__', String(part.inventoryQuantity)) : '') + (!this.preview && part.onOrder ? ' · ' + this.words.on_order : '');
          card.querySelector('[data-price]').textContent = part ? this.money.format(part.price / 100) : '–';
          const img = card.querySelector('img');
          if (img && part && part.image) {if (img.getAttribute('src') !== part.image) {img.removeAttribute('srcset'); img.src = part.image;} img.alt = part.code;}
          if (img) img.hidden = !part;
          card.classList.toggle('is-selected', checkbox.checked);
          if (checkbox.checked && usable) this.selected.push({...part, group});
        });
        const list = this.querySelector('[data-summary]');
        list.replaceChildren();
        this.selected.forEach(part => {const li = document.createElement('li'); const name = document.createElement('span'); const price = document.createElement('span'); name.textContent = this.words[part.group] + ' · ' + (part.quantity > 1 ? part.quantity + ' × ' : '') + part.code; price.textContent = this.money.format(part.price / 100); li.append(name, price); list.append(li);});
        this.querySelector('[data-empty]').hidden = this.selected.length > 0;
        this.querySelector('[data-total]').textContent = this.money.format(this.selected.reduce((sum, part) => sum + part.price, 0) / 100);
        this.submit.disabled = this.busy || this.selected.length === 0 || this.pending;
        if (this.pending) this.status.textContent = this.words.pending;
      }
      async add() {
        if (this.busy || !this.selected.length || this.pending) return;
        if (this.preview) {this.status.textContent = this.words.preview_done; return;}
        this.busy = true;
        this.submit.disabled = true;
        this.submit.textContent = this.words.adding;
        const items = this.selected.map(part => ({id:part.id,quantity:part.quantity,properties:{'Service-Kit':this.querySelector('h1').textContent.trim(),'Modell':this.model.selectedOptions[0].textContent.trim()}}));
        try {
          const response = await fetch(this.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || this.words.error);
          window.location.assign(this.dataset.cartUrl);
        } catch (error) {
          this.status.textContent = error.message || this.words.error;
          this.busy = false;
          this.submit.textContent = this.words.add;
          this.update();
        }
      }
    });
  }

